import React from 'react';
import { EcoAssociation11Class2026 } from '../views';

const AccountGeneralPages = () => {
  return <EcoAssociation11Class2026/>;
};

export default AccountGeneralPages;